import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Terms and Conditions
      </Typography>
      <Typography variant="body1" className={classes.subSection}>
        GmSubs.com offers pre-grading card evaluations as well as submissions to
        PSA, BGS, and SGC. As a result, clients will oftentimes have cards sent
        to multiple grading companies and/or not sent at all. As a courtesy to
        our clients, GmSubs.com will hold raw and already returned graded cards
        for clients (at their request), in an effort to combine return shipping.
        Be advised, it is the client's responsibility to request any and all
        cards being held to be included in return shipping packages. Please
        remind us of these cards when you are contacted about graded cards
        return shipping or they may be shipped separately at your cost.
      </Typography>
      <Typography variant="body1" className={classes.subSection}>
        Be advised, PSA ultimately charges based on the value of your card once
        graded. They can up-charge your card based on recent sales solely at
        their discretion. You card is in a group with other cards, so all
        applicable charges will be paid by GmSubs.com to have the groups cards
        released. Subsequently, you're agreeing to any upcharge ahead of time.
        GmSubs.com has no control over PSA upcharges.
      </Typography>
      <Typography variant="body1" className={classes.subSection}>
        GmSubs.com is not liable or responsible for any loss or damage in
        shipping above and beyond requested insured amounts by client. Ask us
        about insurance coverage for your return shipping.
      </Typography>
    </>
  );
};
